import classNames from 'classnames';
import type { ElementType } from 'react';
import { FaCheckCircle, FaRegClock } from 'react-icons/fa';
import { IoMdPlay } from 'react-icons/io';
import { MdOutlineEditNote } from 'react-icons/md';
import styles from './BadgeStatus.module.scss';

export type Status = 'CURRENT' | 'DRAFT' | 'CLOSED' | 'SCHEDULED';

type BadgeStatusProps = {
  status: Status;
  showIcon?: boolean;
  showLabel?: boolean;
  className?: string;
};

const LABELS: Record<Status, string> = {
  CURRENT: 'Vigente',
  DRAFT: 'Rascunho',
  CLOSED: 'Encerrada',
  SCHEDULED: 'Programada',
};

const ICONS: Record<Status, ElementType> = {
  CURRENT: IoMdPlay,
  DRAFT: MdOutlineEditNote,
  CLOSED: FaCheckCircle,
  SCHEDULED: FaRegClock,
};

const STATUS_CLASS: Record<Status, string> = {
  CURRENT: styles.current,
  DRAFT: styles.draft,
  CLOSED: styles.closed,
  SCHEDULED: styles.scheduled,
};

export const BadgeStatus = ({ status, showIcon = true, showLabel = true, className }: BadgeStatusProps) => {
  const Icon = ICONS[status];
  return (
    <span className={classNames(styles.tag, STATUS_CLASS[status], className)}>
      {showIcon ? <Icon className={styles.icon} /> : null}
      {showLabel ? <span>{LABELS[status]}</span> : null}
    </span>
  );
};
